import React from "react";
import { useSelector } from "react-redux";
import { selectTechnics } from "../labSlice";
import "./technicModal.css";

export default function TechnicModal({
    showTechics,
    setShowTechics,
    showNewTechnicInput,
    IsNewTechnic,
    newTechnicName,
    setNewTechnicName,
    newTechnicSurname,
    setNewTechnicSurname,
    comission,
    handleChangeComission,
    handleClickCreateTechnic,
    handleSaveTechnic,
    handleDeleteTechnic,
    handleClickNewTechnic,
    handleClose,
    handleClickCloseNewTechnic,
    handleSelectTechnic,
    handleEditTechnic
}) {

    const technics = useSelector(selectTechnics)

    const renderListTechnics = technics.map((technic, index) => (
        <div key={index} style={{ marginBottom: '5px' }}>
            <button
                style={{
                    height: '35px',
                    width: '100%',
                    borderColor: '#F2F2F0',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderRadius: '5px',
                    margin: '3px 0',
                    textAlign: 'left',
                    paddingLeft: '10px',
                    fontWeight: 'bold',
                    background: 'white',
                    cursor: 'pointer',
                }}
                onClick={() => handleSelectTechnic(technic.id)}
                onContextMenu={(e) => {
                    e.preventDefault(); // чтобы правый клик не показывал контекстное меню браузера
                    handleEditTechnic(index);
                }}
            >
                {technic.name + ' ' + technic.surname}
            </button>
        </div>
    ));


    if (!showTechics) return null;

    return (
        <div className="modal-overlay" onClick={() => setShowTechics(false)}>
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()} // чтобы клик внутри не закрывал
            >
                {showNewTechnicInput ? (
                    <div className="new-technic-form">
                        <button className="close-btn" onClick={handleClickCloseNewTechnic}>
                            ✖️
                        </button>

                        <h3>{IsNewTechnic ? "Новый техник" : "Редактирование техника"}</h3>

                        <label>Имя</label>
                        <input
                            type="text"
                            value={newTechnicName}
                            onChange={(e) => setNewTechnicName(e.target.value)}
                            placeholder="Иван..."
                        />

                        <label>Фамилия</label>
                        <input
                            type="text"
                            value={newTechnicSurname}
                            onChange={(e) => setNewTechnicSurname(e.target.value)}
                            placeholder="Сидоров..."
                        />

                        <label>Комиссия %</label>
                        <input
                            type="number"
                            value={comission}
                            onChange={(e) => handleChangeComission(e.target.value)}
                            placeholder="10"
                        />

                        <button onClick={IsNewTechnic ? handleClickCreateTechnic : handleSaveTechnic}>
                            {IsNewTechnic ? "Создать" : "Сохранить"}
                        </button>

                        {!IsNewTechnic && (
                            <button onClick={handleDeleteTechnic} style={{ marginTop: "10px" }}>
                                Удалить
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="technic-list">
                        <div className="row_btn">
                            <button className="close-btn_technic" onClick={handleClose}>
                                ✖️
                            </button>
                            <button className="new-technic-btn_technic" onClick={handleClickNewTechnic}>
                                ➕
                            </button>
                        </div>
                        <h3 style={{ textAlign: "center", marginTop: "20px" }}>Техники</h3>
                        <div className="technic-scroll">{renderListTechnics}</div>
                    </div>
                )}
            </div>
        </div>
    );
}
